import { render, staticRenderFns } from "./modalEditarCliente.vue?vue&type=template&id=6a2b479e"
import script from "./modalEditarCliente.vue?vue&type=script&lang=js"
export * from "./modalEditarCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports